import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { Viewer } from '@ugla-france/ugla-3d-library';
import styled from 'styled-components';
import Viewer360 from './Viewer360';
import Loading from './loading';

interface ViewerContainerProps {
  scale?: number;
  className?: string;
  is360?: boolean;
  url360?: string;
}

/**
 * Container component that wraps the Viewer from @ugla-france/ugla-3d-library
 * Handles initialization and display of 2D assets as layers
 */
const ViewerContainer: React.FC<ViewerContainerProps> = ({
  scale = 1,
  className,
  is360,
  url360
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [viewerScale, setViewerScale] = useState(scale);
  const theme = useTheme();

  // Update scale when prop changes
  useEffect(() => {
    setViewerScale(scale);
  }, [scale]);

  // Handle window resize to adjust viewer scale
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const mobile = parseInt(theme.breakpoints!.mobile, 10);
      const tablet = parseInt(theme.breakpoints!.tablet, 10);
      const desktop = parseInt(theme.breakpoints!.desktop, 10);
      const largeDesktop = parseInt(theme.breakpoints!.largeDesktop, 10);
      let newScale = 1;
      if (width < mobile) {
        newScale = 0.2;
      } else if (width < tablet) {
        newScale = 0.4;
      } else if (width < desktop) {
        newScale = 0.6;
      } else if (width < largeDesktop) {
        newScale = 0.7;
      } else {
        newScale = 0.8;
      }
      setViewerScale(newScale);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Container className={className}>
      <ViewerWrapper>
        {
          is360 && !!url360 ?
          <Viewer360 url={url360}/> :
          <Viewer
            scale={viewerScale}
            canvasRef={canvasRef as React.RefObject<HTMLCanvasElement>}
            disableInstancing={true}
            disableControls={false}
            loadingComponent={Loading}
          />
        }
      </ViewerWrapper>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
`;

const ViewerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ViewerContainer;
